<template>
  <el-select
    v-model="dataValue"
    placeholder="请选择批量导入状态"
    @change="onChange">
    <el-option
      v-for="item in OrderUploadStatus"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
import { OrderUploadStatus } from '@/utils/enum'
export default {
  name: 'UploadStatusSelect',
  props: {
    value: { type: Number }
  },
  data() {
    return { OrderUploadStatus }
  },
  computed: {
    dataValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onChange() {

    }
  }
}
</script>
